import { NavConfig, ViewName } from '@pressreader/navigation-types';

import { IssueNavConfig } from './issue.nav.config';

interface TextViewNavConfig extends IssueNavConfig {
    /** Defines whether PageView thumbs were shown, so when navigating back to PageView don't show them again. */
    pageViewThumbsShown?: boolean;

    /** Translation was requested from page view. */
    language?: string | null;
}

function isTextViewNavConfig(navConfig: NavConfig | null): navConfig is TextViewNavConfig {
    return navConfig?.viewName === ViewName.TextView;
}

export { isTextViewNavConfig, TextViewNavConfig };
